import { useFestiveStore } from '@/stores/useFestiveStore'
import { driver } from 'driver.js'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Switch, Text } from '@vnetwork/datacentral-ui/primitives'

const FestiveSwitch = () => {
    const { t } = useTranslation()
    const { isFestiveEnabled, setFestiveEnabled } = useFestiveStore()
    const [outdated] = useState(() => new Date() > new Date('2025-12-27'))

    useEffect(() => {
        if (outdated) {
            setFestiveEnabled(false)
            localStorage.removeItem('festive-guide-shown')
        }
    }, [outdated, setFestiveEnabled])

    useEffect(() => {
        if (outdated) return
        const hasSeenGuide = localStorage.getItem('festive-guide-shown')

        if (!hasSeenGuide) {
            setFestiveEnabled(true)

            const timer = setTimeout(() => {
                const driverInstance = driver({
                    showButtons: ['close'],
                    steps: [
                        {
                            element: '#festive-switch-container',
                            popover: {
                                title: t('festive.guide-title'),
                                description: t('festive.guide-description'),
                                side: 'bottom',
                                align: 'center',
                            },
                        },
                    ],
                    onDestroyed: () => {
                        localStorage.setItem('festive-guide-shown', 'true')
                    },
                })

                driverInstance.drive()
            }, 1000)

            return () => clearTimeout(timer)
        }
    }, [outdated, t])

    if (outdated) return null

    return (
        <div
            id="festive-switch-container"
            className="items-center gap-2 hidden md:flex"
        >
            <Text size="sm" weight="medium">
                Let it snow
            </Text>
            <Switch
                size="sm"
                checked={isFestiveEnabled}
                onCheckedChange={setFestiveEnabled}
            />
        </div>
    )
}

export default FestiveSwitch
